import React from 'react';
import roles from 'helpers/roles';
import { withTranslation } from 'react-i18next';
import getReportFileName from 'helpers/getReportFileName';

import BaseBrandReport from './BaseBrandReport';

class RecipeStickers extends React.Component {
  render() {
    const { t } = this.props;
    const title = t('common.mainMenu.reportRecipeStickers');

    return (
      <BaseBrandReport
        title={title}
        excelUrl="reports/stickers-recipe"
        fileName={getReportFileName(title)}
        role={roles.ROLE_SHOW_REPORT_RECIPE_STICKERS}
        pdfAvailable={false}
        excelAvailable={true}
        previewXlsxAvailable={true}
        dateType="range"
        archiveReportNames={['RECIPE_STICKERS']}
        isSalesMarketLangViewEnabled={true}
      />
    );
  }
}

export default withTranslation()(RecipeStickers);
